import { render } from "./BackerCenterSection.vue?vue&type=template&id=5c572198"
import script from "./BackerCenterSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__